const open = () => {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({
      type: 'bluetooth_settings',
      payload: { action: 'open' },
    }),
  );
};

export default {
  open,
};
